import React, {useState, forwardRef, useCallback} from 'react';
import classnames from 'classnames';
import {makeStyles} from '@material-ui/core/styles';
import {useSnackbar} from 'notistack';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minWidth: '344px !important',
    },
  },
  card: {
    backgroundColor: '#d32f2f',
    width: '100%',
  },
  typography: {
    fontWeight: '400',
    color: 'white',
  },
  actionRoot: {
    padding: '8px 8px 8px 16px',
    justifyContent: 'space-between',
  },
  icons: {
    marginLeft: 'auto',
  },
  expand: {
    padding: '8px 8px',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    color: 'white',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
    color: 'white',
  },
  collapse: {
    padding: 16,
  },
  errorIcon: {
    verticalAlign: 'bottom',
  },
}));

const ExpandableSnackbar = forwardRef((props, ref) => {
  const classes = useStyles();
  const {closeSnackbar} = useSnackbar();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = useCallback(() => {
    setExpanded((oldExpanded) => !oldExpanded);
  }, []);

  const handleDismiss = useCallback(() => {
    closeSnackbar(props.id);
  }, [props.id, closeSnackbar]);

  return (
    <div ref={ref} className={classes.root}>
      <Card className={classes.card}>
        <CardActions classes={{root: classes.actionRoot}}>
          <Typography variant="subtitle2" className={classes.typography}>
            <ErrorOutlineIcon className={classes.errorIcon} /> {props.message}
          </Typography>
          <div className={classes.icons}>
            <IconButton
              aria-label="Show more"
              className={classnames(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}>
              <ExpandMoreIcon />
            </IconButton>
            <IconButton className={classes.expand} onClick={handleDismiss}>
              <CloseIcon />
            </IconButton>
          </div>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Paper className={classes.collapse}>{props.children}</Paper>
        </Collapse>
      </Card>
    </div>
  );
});

export default ExpandableSnackbar;
